import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { View } from './components/View';

const widgetsBreadCrumbs: Array<PageLink> = [];

const BoxCutPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>
        Corte de caja y día
      </PageTitle>
      <View />
    </>
  );
};

export { BoxCutPage };
